module.exports = __webpack_public_path__ + "assets/img/img_slbj_n.ba6ceb98.png";